import * as React from "react";
import { AlbumChart } from "./charts/AlbumChart";
import { ArtistChart } from "./charts/ArtistChart";
import { DownloadChart } from "./charts/DownloadChart";
import { StreamChart } from "./charts/StreamChart";
import { TrackChart } from "./charts/TrackChart";
import { ViewChart } from "./charts/ViewChart";
import { QueryProvider, Field } from "../../../components/context/query";

const allowedFields: Field[] = [{
    dataField: 'label',
    caption: 'Label',
    dataType: 'string'
}, {
    dataField: 'sub_label',
    caption: 'Sublabel',
    dataType: 'string'
}, {
    dataField: 'name',
    caption: 'Album Name',
    dataType: 'string'
}, {
    dataField: 'artist',
    dataType: 'string'
}, {
    dataField: 'bpm',
    caption: 'BPM',
    dataType: 'number'
}, {
    dataField: 'key',
    dataType: 'string'
}, {
    dataField: 'genre_name',
    caption: 'Genre Name',
    dataType: 'string'
}, {
    dataField: 'category_name',
    caption: 'Category Name',
    dataType: 'string'
}, {
    dataField: 'tag_name',
    caption: 'Tag Name',
    dataType: 'string'
}]
export class Categories extends React.Component {

    componentDidMount() {
        setImmediate(() => {
            document.dispatchEvent(new CustomEvent('datefilter', { detail: false }))
        })
    }

    componentWillUnmount() {
        document.dispatchEvent(new CustomEvent('datefilter', { detail: true }))
    }

    render() {
        return <div className="dashboard">
            <div className='charts'>
                <QueryProvider fields={allowedFields}>{({ filter }) => {
                    return <div className='bpm-container'>
                        <div className='row'>
                            <div className='col'>
                                {filter}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <ArtistChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <AlbumChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <TrackChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <DownloadChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <StreamChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <ViewChart />
                            </div>
                        </div>
                    </div>
                }}</QueryProvider>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Category/Category.tsx